import { useEffect } from "react";
import { LanguageService } from "src/services/Language";
import { isIntegratedSession } from "./isEmbedded";
import { CHANGE_LANGUAGE_MESSAGE_TYPE, ChangeLanguageMessagePayload } from "./postMessageTypes";
import { isAllowedOrigin } from "./originUtils";

export default function useParentLanguageListener() {
  useEffect(() => {
    if (!isIntegratedSession()) return;

    function handleMessage(event: MessageEvent) {
      if (!isAllowedOrigin(event.origin)) return;
      const { type, payload } = (event.data ?? {}) as { type?: string; payload?: ChangeLanguageMessagePayload };
      if (type !== CHANGE_LANGUAGE_MESSAGE_TYPE) return;
      if (payload?.lang !== "ar" && payload?.lang !== "en") return;

      LanguageService.changeLanguage(payload.lang);
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
}
